module.exports = __webpack_public_path__ + "721747e0e39a805a7c6111f43f36577b.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-400.woff
// module id = 169
// module chunks = 1